"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPanelSettingsView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const UserPanelSectionView_1 = require("./UserPanelSectionView");
const PasswordGrid = (0, app_1.styled)(ui_1.Grid) `
  @media ${app_1.mobile} {
    grid-template-columns: minmax(0, 1fr);
    grid-gap: ${(theme) => theme.spacing.extraSmall};
  }
`;
const SectionTitle = (0, app_1.styled)(app_1.Text) `
  font-size: 1.0625rem;
  font-weight: 500;
`;
const Description = (0, app_1.styled)(app_1.Text) `
  font-size: 0.9375rem;
  color: ${(theme) => theme.colors.gray.dark};
`;
const NewsletterInfo = app_1.styled.span `
  font-size: 0.9375rem;
  color: ${(theme) => theme.colors.gray.dark};
`;
const PasswordSubmit = (0, app_1.styled)(ui_1.Submit) `
  flex: 1;
  height: 3.5rem;
  background: ${(theme) => theme.colors.gray};
  color: white;
  border-radius: ${(theme) => theme.radius.small};
`;
const StyledCard = (0, app_1.styled)(ui_1.Card) `
  background: #fbfbfb;
  max-width: 35rem;
  color: #000000;
  border-radius: ${(theme) => theme.radius.small};
  position: relative;
`;
const UserPanelEditButton = (0, app_1.styled)(ui_1.Button) `
  position: absolute;
  top: ${(theme) => theme.spacing.small};
  right: ${(theme) => theme.spacing.small};
`;
const CardDataTitle = app_1.styled.span `
  font-size: 0.9375rem;
  letter-spacing: 0.015625rem;
  color: ${(theme) => theme.colors.gray.dark};
`;
const CardDataValue = app_1.styled.span `
  font-size: 1.0625rem;
  font-weight: 500;
`;
const UserNameWrap = (0, app_1.styled)(ui_1.Stack) `
  align-items: center;
`;
const StyledPasswordInput = (0, app_1.styled)(ui_1.PasswordInput) `
  height: 3.5rem;
  border: 1px solid ${(theme) => theme.stroke};
  border-radius: ${(theme) => theme.radius.small};
`;
function UserPanelCardData({ title, value, }) {
    return ((0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(CardDataTitle, { children: title }), (0, jsx_runtime_1.jsx)(CardDataValue, { children: value })] })));
}
function UserPanelCard({ user, openModal }) {
    var _a;
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(StyledCard, { children: (0, jsx_runtime_1.jsxs)(ui_1.Card.Section, { children: [(0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical" }, { children: [(0, jsx_runtime_1.jsxs)(UserNameWrap, { children: [(0, jsx_runtime_1.jsx)(ui_1.Avatar, { name: "avatar", size: "4.5rem" }), (0, jsx_runtime_1.jsx)(UserPanelCardData, { title: t('label.fullName'), value: user.name })] }), (0, jsx_runtime_1.jsx)(UserPanelCardData, { title: t('label.phone'), value: (_a = user.phone) !== null && _a !== void 0 ? _a : '--' }), (0, jsx_runtime_1.jsx)(UserPanelCardData, { title: t('label.email'), value: user.email })] })), (0, jsx_runtime_1.jsx)(UserPanelEditButton, Object.assign({ kind: ['icon', 'transparent'], onClick: openModal }, { children: (0, jsx_runtime_1.jsx)(svg_1.SvgFullyCustomMade, {}) }))] }) }));
}
function UserPanelPasswordChange() {
    const { t } = (0, app_1.useTranslation)();
    const [changePassword] = (0, app_1.useMutation)('changePassword');
    const handleSubmit = ({ oldPassword, newPassword, }) => {
        void changePassword({ newPassword, password: oldPassword });
        return ui_1.SubmitState.OK;
    };
    return ((0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical" }, { children: [(0, jsx_runtime_1.jsx)(SectionTitle, Object.assign({ tag: "h2" }, { children: t('info.changeOfPassword') })), (0, jsx_runtime_1.jsx)(Description, { children: t('info.changeOfPasswordDescription') }), (0, jsx_runtime_1.jsx)(ui_1.Form, Object.assign({ contextOnly: true, onSubmit: handleSubmit }, { children: (0, jsx_runtime_1.jsxs)(PasswordGrid, Object.assign({ templateColumns: "repeat(2, minmax(0,2fr)) 1fr", gap: "small" }, { children: [(0, jsx_runtime_1.jsx)(StyledPasswordInput, { toggle: true, containerCss: (0, app_1.css) `
              flex: 3;
            `, name: "oldPassword", placeholder: "Bie\u017C\u0105ce has\u0142o" }), (0, jsx_runtime_1.jsx)(StyledPasswordInput, { toggle: true, containerCss: (0, app_1.css) `
              flex: 3;
            `, name: "newPassword", placeholder: "Nowe has\u0142o" }), (0, jsx_runtime_1.jsx)(PasswordSubmit, { children: "Zapisz" })] })) }))] })));
}
const NewsletterWrap = app_1.styled.div `
  display: flex;
  justify-content: space-between;
`;
function UserPanelNewsletters() {
    const { t } = (0, app_1.useTranslation)();
    const [changeNewsletter] = (0, app_1.useMutation)('setNewsletterStatus');
    const handleSwitch = (newsletter) => {
        void changeNewsletter({ newsletter });
        return newsletter;
    };
    return ((0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical" }, { children: [(0, jsx_runtime_1.jsx)(SectionTitle, { children: t('info.newsletters') }), (0, jsx_runtime_1.jsx)(ui_1.Stack, Object.assign({ kind: "vertical", divider: true }, { children: (0, jsx_runtime_1.jsxs)(NewsletterWrap, { children: [(0, jsx_runtime_1.jsx)(NewsletterInfo, { children: t('checkbox.newsletterStore') }), (0, jsx_runtime_1.jsx)(ui_1.Switch, { name: "newsletter", onChange: handleSwitch })] }) }))] })));
}
function UserPanelSettingsView({ user, openModal, }) {
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(UserPanelSectionView_1.UserPanelSectionView, Object.assign({ title: t('user.accountSettings') }, { children: (0, jsx_runtime_1.jsx)(ui_1.Stack, Object.assign({ kind: "vertical", divider: true }, { children: user ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(UserPanelCard, { user: user, openModal: openModal }), (0, jsx_runtime_1.jsx)(UserPanelPasswordChange, {}), (0, jsx_runtime_1.jsx)(UserPanelNewsletters, {}), ' '] })) : ((0, jsx_runtime_1.jsx)(ui_1.LoadingGlobal, {})) })) })));
}
exports.UserPanelSettingsView = UserPanelSettingsView;
